import { all, put, takeLatest } from 'redux-saga/effects';
import {
  initialization,
  fetchCurrencyDefinitions,
  fetchLifecycleStages,
  fetchMonthlyExchangeRates,
  fetchUsers,
  fetchSystemFields,
  fetchFieldDefinitions,
  getPartialAccountsList,
  getPartialContactsList,
  getPartialOrganizationsList,
  getPartialPipelinesList,
  fetchActivityTypesLookup,
  organizationFetchData,
  accountFetchData,
  contactFetchData,
  pipelineFetchData,
} from '../routines';
import {
  fetchMilestoneStatusLookups,
  fetchSuccessPlanProgressLookups,
  fetchSuccessPlanStatusLookups,
  fetchKPIProgressLookups,
  fetchMilestoneStatusLookupsV2,
  fetchSuccessPlanProgressLookupsV2,
  fetchSuccessPlanStatusLookupsV2,
  fetchKPIProgressLookupsV2,
} from '../routines/successPlanRoutines';
import { fetchIntegrations } from '../routines/integrations/integrationDataRoutines';
import { fetchFilteredViews } from '../routines/filteredViewsRoutines';
import constants from '../../common/constants/CommonConstants';
import { gptKeyExists } from '../routines/velarisAiRoutines';
import {
  fetchCustomObjects,
  fetchCustomObjectsLimit,
} from '../routines/customObjectRoutines';

import {
  ACCOUNT,
  CONTACT,
  PIPELINE,
  ORGANIZATION,
} from '../../common/constants/TableColumnScopeConstants';

export function* initializationSaga() {
  try {
    yield all([
      put(
        fetchFieldDefinitions({
          scope: ORGANIZATION,
          level: constants.ORGANIZATION_LEVEL,
        })
      ),
      put(
        fetchFieldDefinitions({
          scope: ACCOUNT,
          level: constants.ACCOUNT_LEVEL,
        })
      ),
      put(
        fetchFieldDefinitions({
          scope: CONTACT,
          level: constants.CONTACT_LEVEL,
        })
      ),
      put(
        fetchFieldDefinitions({
          scope: PIPELINE,
          level: constants.PIPELINE_LEVEL,
        })
      ),
      put(fetchCustomObjects()),
      put(fetchCustomObjectsLimit()),
      put(fetchSystemFields()),
      put(fetchActivityTypesLookup()),
      put(getPartialOrganizationsList()),
      put(getPartialAccountsList()),
      put(getPartialContactsList()),
      put(getPartialPipelinesList()),
      put(organizationFetchData()),
      put(accountFetchData()),
      put(contactFetchData()),
      put(pipelineFetchData()),
      put(fetchUsers()),
      put(fetchLifecycleStages(constants.ORGANIZATION_LEVEL)),
      put(fetchLifecycleStages(constants.ACCOUNT_LEVEL)),
      put(fetchLifecycleStages(constants.CONTACT_LEVEL)),
      put(fetchLifecycleStages(constants.OPPORTUNITY_LEVEL)),
      put(fetchLifecycleStages(constants.RISK_LEVEL)),
      put(fetchCurrencyDefinitions()),
      put(fetchMonthlyExchangeRates()),
      put(fetchIntegrations()),
      put(fetchSuccessPlanStatusLookups()),
      put(fetchSuccessPlanProgressLookups()),
      put(fetchMilestoneStatusLookups()),
      put(fetchMilestoneStatusLookupsV2()),
      put(fetchSuccessPlanProgressLookupsV2()),
      put(fetchSuccessPlanStatusLookupsV2()),
      put(fetchKPIProgressLookupsV2()),
      put(fetchKPIProgressLookups()),
      put(fetchFilteredViews()),
      put(gptKeyExists()),
    ]);
  } catch (error) {
    yield put(initialization.failure({ error }));
  } finally {
    yield put(initialization.fulfill());
  }
}

export default function* root() {
  yield all([takeLatest(initialization.TRIGGER, initializationSaga)]);
}
